import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Divider,
  Stack
} from "@mui/material";

const ViewAnnouncementDialog = ({ show, handleClose, data }) => {
  if (!data) return null;

  return (
    <Dialog open={show} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>📢 View Announcement</DialogTitle>
      <Divider />
      <DialogContent>
        <Stack spacing={2}>
          <div>
            <Typography variant="subtitle2" color="textSecondary">
              Title
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#000",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word"
              }}
            >
              {data.title}
            </Typography>
          </div>
          <div>
            <Typography variant="subtitle2" color="textSecondary">
              Message
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#000",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word"
              }}
            >
              {data.message}
            </Typography>
          </div>
          <div>
            <Typography variant="subtitle2" color="textSecondary">
              Active
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#000",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word"
              }}
            >
              {data.active ? "Yes" : "No"}
            </Typography>
          </div>
          <div>
            <Typography variant="subtitle2" color="textSecondary">
              Created At
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#000",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word"
              }}
            >
              {new Date(data.created_at).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric"
              })}
            </Typography>
          </div>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={handleClose} variant="outlined" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewAnnouncementDialog;
